import { render, staticRenderFns } from "./card-list-skeleton.vue?vue&type=template&id=16bf574f&scoped=true&"
import script from "./card-list-skeleton.component.ts?vue&type=script&lang=ts&"
export * from "./card-list-skeleton.component.ts?vue&type=script&lang=ts&"
import style0 from "./card-list-skeleton.vue?vue&type=style&index=0&id=16bf574f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf574f",
  null
  
)

export default component.exports